var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
var Icon = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n"], ["\n    color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorNavIcon || '#fff';
});
export var GoBackSvg = function () { return (React.createElement(Icon, { viewBox: "0 0 32 32" },
    React.createElement("circle", { style: { fill: 'none' }, cx: "16", cy: "16", r: "16" }),
    React.createElement("path", { fill: "currentColor", d: "M16 32C7.178 32 0 24.822 0 16S7.178 0 16 0s16 7.178 16 16-7.178 16-16 16zm0-31C7.729 1 1 7.729 1 16s6.729 15 15 15 15-6.729 15-15S24.271 1 16 1z" }),
    React.createElement("path", { style: { fill: 'none' }, transform: "rotate(-45.001 17.717 16.13)", d: "M12.23 10.46h10.973v11.339H12.23z" }),
    React.createElement("path", { fill: "currentColor", d: "M24 15H10.828l6.76-6.759-1.415-1.414L7 16l9.432 9.432 1.414-1.414L10.828 17H24z" }))); };
var templateObject_1;
//# sourceMappingURL=GoBackSvg.js.map